import { Box, Skeleton, Typography } from "@mui/material";
import {
	getMonthWeeks,
	toDateKey,
	WEEKDAY_LABELS,
} from "../utils/calendarUtils";

export const MonthGridSkeleton = ({ currentDate }: { currentDate: Date }) => {
	const weeks = getMonthWeeks(currentDate);

	return (
		<Box
			sx={{
				border: "1px solid",
				borderColor: "divider",
				borderRadius: 1,
				overflow: "hidden",
			}}
		>
			<Box
				sx={{
					display: "grid",
					gridTemplateColumns: "repeat(7, 1fr)",
					backgroundColor: "grey.100",
					borderBottom: "1px solid",
					borderColor: "divider",
				}}
			>
				{WEEKDAY_LABELS.map((label) => (
					<Typography
						key={label}
						variant="caption"
						sx={{ p: 0.75, textAlign: "center", fontWeight: 600 }}
					>
						{label}
					</Typography>
				))}
			</Box>

			{weeks.map((week) => (
				<Box
					key={toDateKey(week[0])}
					sx={{
						display: "grid",
						gridTemplateColumns: "repeat(7, 1fr)",
						borderBottom: "1px solid",
						borderColor: "divider",
						"&:last-child": { borderBottom: "none" },
					}}
				>
					{week.map((day, dayIndex) => (
						<Box
							key={toDateKey(day)}
							sx={{
								minHeight: 118,
								p: 0.75,
								borderRight: "1px solid",
								borderColor: "divider",
								"&:last-child": { borderRight: "none" },
							}}
						>
							<Skeleton variant="text" width={20} />
							{dayIndex % 3 !== 2 && (
								<Skeleton
									variant="rounded"
									height={14}
									sx={{ mt: 0.5, borderRadius: 0.5 }}
								/>
							)}
							{dayIndex % 4 === 1 && (
								<Skeleton
									variant="rounded"
									height={14}
									sx={{ mt: 0.25, borderRadius: 0.5 }}
								/>
							)}
						</Box>
					))}
				</Box>
			))}
		</Box>
	);
};
